<div class="content-margin settings-page">
  <h1 class="ewrs-page-title">Settings</h1>
  <app-edit-user-fields></app-edit-user-fields>
</div>
